import { type BirthDateType } from 'ui/Form/BirthDatePicker';

export const isDateOfBirthValid = (value: BirthDateType) => {
  return value?.date;
};
